'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var withParams = 'lib' === 'web' ? require('./withParamsBrowser').default : require('./index').withParams;

exports.default = withParams;


//////////////////
// WEBPACK FOOTER
// ./~/vuelidate/lib/withParams.js
// module id = 15
// module chunks = 0